import { render, staticRenderFns } from "./AccountControls.vue?vue&type=template&id=5b5b3b4e"
import script from "./AccountControls.vue?vue&type=script&lang=js"
export * from "./AccountControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports